import { render } from "./CodeMirror.vue?vue&type=template&id=4eea9ae1"
import script from "./CodeMirror.vue?vue&type=script&lang=js"
export * from "./CodeMirror.vue?vue&type=script&lang=js"

import "./CodeMirror.vue?vue&type=style&index=0&id=4eea9ae1&lang=css"

import exportComponent from "/builds/weborigo-projects/vivien-vance/webshop/core-editor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__